<template>
  <div>
    <h1>Listagem de regiões prazo entrega</h1>
    <div>
      <b-table striped hover :items="items" :fields="fields">
        <template v-slot:cell(paisId)="row">
          <b-form-select v-model="row.item.paisId" :options="optionsPais"></b-form-select>
        </template>
        <template v-slot:cell(estadoId)="row">
          <b-form-select v-model="row.item.estadoId" :options="optionsEstados"></b-form-select>
        </template>
        <template v-slot:cell(prazo)="row">
          <b-form-input v-model="row.item.prazo" />
        </template>
        <template v-slot:cell(diasPosColeta)="row">
          <b-form-input v-model="row.item.diasPosColeta" />
        </template>
      </b-table>
      {{ items }}
    </div>
  </div>
</template>

<script>
export default {
  name: "List",
  data: function() {
    return {
      fields: [
        {
          key: "id",
          sortable: true
        },
        {
          key: "paisId",
          sortable: true
        },
        {
          key: "regiaoPaisId",
          sortable: true
        },
        {
          key: "estadoId",
          sortable: true
        },
        {
          key: "regiaoEstadoId",
          sortable: true
        },
        {
          key: "municipioId",
          sortable: true
        },
        {
          key: "cep",
          sortable: true
        },
        {
          key: "prazo",
          sortable: true
        },
        {
          key: "diasPosColeta",
          sortable: true
        }
      ],
      items: [],
      optionsEstados: [],
      optionsPais: [],
      optionsRegioesEstados: [],
      optionsRegioesPaises: [],
      optionsMunicipios: [],
    };
  },
  created: function() {
    this.loadEstados();
    this.loadPaises();
    this.loadRegioesEstados();
    this.loadRegioesPaises();
    this.loadMunicipios();
    this.loadData();
  },
  methods: {
    async loadData() {
      const r = await fetch("http://3.136.82.117:81/rotaPrazoEntrega");
      this.items = await r.json();
    },
    async loadEstados() {
      const data = await fetch("http://3.136.82.117:81/estado");
      const dataJson = await data.json();
      dataJson.forEach(item => {
        this.optionsEstados.push({
          value: item.id.toString(),
          text: item.nome
        });
      });
    },
    async loadPaises() {
      const data = await fetch("http://3.136.82.117:81/pais");
      const dataJson = await data.json();
      dataJson.forEach(item => {
        this.optionsPais.push({
          value: item.id.toString(),
          text: item.nome
        });
      });
    },
    async loadRegioesEstados() {
      const data = await fetch("http://3.136.82.117:81/regiaoEstado");
      const dataJson = await data.json();
      dataJson.forEach(item => {
        this.optionsRegioesEstados.push({
          value: item.id.toString(),
          text: item.nome
        });
      });
    },
    async loadRegioesPaises() {
      const data = await fetch("http://3.136.82.117:81/regiaoPais");
      const dataJson = await data.json();
      dataJson.forEach(item => {
        this.optionsRegioesPaises.push({
          value: item.id.toString(),
          text: item.nome
        });
      });
    },
    async loadMunicipios() {
      const data = await fetch("http://3.136.82.117:81/municipio");
      const dataJson = await data.json();
      dataJson.forEach(item => {
        this.optionsMunicipios.push({
          value: item.id.toString(),
          text: item.nome
        });
      });
    },
  }
};
</script>

